import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringify',
    standalone: false
})
export class StringifyPipe implements PipeTransform {

  transform(key: unknown): string {
    if (key) {
      return String(key);
    }
    
    return '';
  }

}
